module.exports = __webpack_public_path__ + "static/img/jtlogo.b8ba5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/jtlogo.png
// module id = VGQX
// module chunks = 21